var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-columns"},_vm._l((_vm.columns),function(column,col_index){return _c('div',{key:col_index},_vm._l((column),function(line,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(line)}})}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }